import axios from './_nestAxios'

export const getxIdAsEdicion = _id => axios.get(`/plantillas-contabilidad/${_id}`)

export const obtenerxOrigen = origen =>
  axios.get('/plantillas-contabilidad', {
    params: { tipoConsulta: 'x-origen', origen }
  })

export const getxOrigenAsSelect = (origen, tipoSocio) =>
  axios.get('/plantillas-contabilidad', { params: { tipoConsulta: 'select', origen, tipoSocio } })

export const nuevo = data => axios.post('/plantillas-contabilidad', data)

export const actualizarxId = (_id, data) => axios.put(`/plantillas-contabilidad/${_id}`, data)

export const eliminarxId = _id => axios.delete(`/plantillas-contabilidad/${_id}`)
